export const ANNOUNCEMENTS_LOCALSTORAGE = 'oskari-announcements';
